module.exports = __webpack_public_path__ + "static/img/butterflies-right--small.e329562.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-grounds/butterflies-right--small.svg
// module id = 171
// module chunks = 2